module.exports = __webpack_public_path__ + "img/hr.4680d632.svg";